// export let URL_ROOT =
//   process.env.NODE_ENV === 'production'
//     ? 'http://luminairebroker-dev.atessoft.rs:8080'
//     : 'http://luminaire-aca.atessoft.rs:8080';
// //: 'http://luminairebroker-dev.atessoft.rs:8080';

// if (window.location.href.indexOf('arup') > -1) {
//   URL_ROOT = 'http://luminairebroker-arup.atessoft.rs:8080';
// }

export const URL_ROOT = `${process.env.BACKEND_URL}:${process.env.BACKEND_PORT}`;
// export const URL_ROOT = `http://192.168.1.18:8080`;

export const API_ROOT = `${URL_ROOT}/api`;
//initial-resource

export const INITIAL_LOAD = `${API_ROOT}/init`;

export const ASSETS_ROUTE = `${API_ROOT}/asset/`;

//authentication-resource

export const POST_LOGIN_USER = `${API_ROOT}/auth`;
export const POST_REFRESH_TOKEN = `${API_ROOT}/auth/refresh`;

//user-resource

export const GET_USERS = `${API_ROOT}/users`;
export const GET_CURRENT_USER = `${API_ROOT}/me`;
export const GET_FIND_USER = `${API_ROOT}/user/find`;

//project-resource

export const PROJECTS_ENDPOINT = `${API_ROOT}/project`;
export const GET_PROJECT_USAGES = `${PROJECTS_ENDPOINT}/usages`;
export const usersAccepted = projectId =>
  `${PROJECTS_ENDPOINT}/${projectId}/users-accepted`;
export const usersInvited = projectId =>
  `${PROJECTS_ENDPOINT}/${projectId}/users-invited`;
export const inviteUserToProject = projectId =>
  `${PROJECTS_ENDPOINT}/${projectId}/invite`;
export const acceptInvitationToProject = projectId =>
  `${PROJECTS_ENDPOINT}/${projectId}/accept`;
export const declineInvitationToProject = projectId =>
  `${PROJECTS_ENDPOINT}/${projectId}/decline`;
export const removeUserFromProject = (projectId, userId) =>
  `${PROJECTS_ENDPOINT}/${projectId}/user/${userId}`;
export const USER_INVITATIONS = `${API_ROOT}/user/invitations`;

//ticket-resource
export const ticketBasicRoute = projectId =>
  `${PROJECTS_ENDPOINT}/${projectId}/ticket`;
export const ticketDraftRoute = projectId =>
  `${PROJECTS_ENDPOINT}/${projectId}/ticket/add-draft`;

export const ticketRoute = (projectId, ticketId, route = false) =>
  route
    ? `${PROJECTS_ENDPOINT}/${projectId}/ticket/${ticketId}/${route}`
    : `${PROJECTS_ENDPOINT}/${projectId}/ticket/${ticketId}/view`;

export const ticketRouteDelete = (projectId, ticketId, route = false) =>
  route
    ? `${PROJECTS_ENDPOINT}/${projectId}/ticket/${ticketId}/${route}`
    : `${PROJECTS_ENDPOINT}/${projectId}/ticket/${ticketId}`;
export const ticketRouteToggleFavorite = (projectId, ticketId) =>
  `${PROJECTS_ENDPOINT}/${projectId}/ticket/${ticketId}/mark_or_remove_favorite`;

//criteria-resource
export const CRITERIA_ENDPOINT = `${API_ROOT}/criteria`;
export const VALUE_PATTERNS = `${CRITERIA_ENDPOINT}/value-patterns`;
export const singleCriteria = criteriaId =>
  `${CRITERIA_ENDPOINT}/${criteriaId}`;

//slips-resource

export const SLIP_ENDPOINT = `${API_ROOT}/slip`;
export const putSlipStateRoute = slipId =>
  `${SLIP_ENDPOINT}/${slipId}/demand/change_slip_state`;
export const allSlipsForTicketRoute = ticketId =>
  `${API_ROOT}/ticket/${ticketId}/slip`;
export const singleSlipRoute = slipId => `${SLIP_ENDPOINT}/${slipId}`;
export const getCircularEconomyRoute = slipId =>
  `${API_ROOT}/circular_economy/ticket/slip/${slipId}/answers`;
export const shortlistSlipRoute = slipId =>
  `${SLIP_ENDPOINT}/${slipId}/shortlist`;
export const discardSlipRoute = slipId => `${SLIP_ENDPOINT}/${slipId}/discard`;
export const rateSlipRoute = slipId => `${SLIP_ENDPOINT}/${slipId}/rate`;
export const addQuantitiesToSlipRoute = slipId =>
  `${SLIP_ENDPOINT}/${slipId}/create_quantity`;

//admin-resource

export const ADMIN_ENDPOINT = `${API_ROOT}/admin`;
export const ADMIN_DASHBOARD = `${ADMIN_ENDPOINT}/dashboard`;
export const USERS_DASHBOARD = `${ADMIN_ENDPOINT}/users`;
export const COMPANY_DASHBOARD = `${ADMIN_ENDPOINT}/company`;
export const AdminUserDetails = (userId, companyId) =>
  `${USERS_DASHBOARD}/${companyId}/${userId}`;
export const AdminCompanyDetails = companyId =>
  `${COMPANY_DASHBOARD}/${companyId}`;
export const AdminDeactivateUser = (companyId, userId) =>
  `${USERS_DASHBOARD}/${companyId}/${userId}/deactivate`;
export const AdminDeactivateUserPerma = (companyId, userId) =>
  `${USERS_DASHBOARD}/${companyId}/${userId}/deactivate_permanently`;
export const AdminApproveUser = (companyId, userId) =>
  `${COMPANY_DASHBOARD}/${companyId}/approve`;
export const AdminDeclineUser = (companyId, userId) =>
  `${COMPANY_DASHBOARD}/${companyId}/decline`;

//user-resource

export const SUPPLY_DASHBOARD_DATA = `${API_ROOT}/supply/user/dashboard`;
export const DEMAND_DASHBOARD_DATA = `${API_ROOT}/demand/user/dashboard`;

//import-export excel
export const excelImportAll = projectId =>
  `${API_ROOT}/schedule/importAll/${projectId}`;
export const excelImportNew = projectId =>
  `${API_ROOT}/schedule/importOnlyNew/${projectId}`;
export const excelImportManually = (projectId, referenceNames) =>
  `${API_ROOT}/schedule/importManually/${projectId}/${referenceNames}`;
export const excelImportTypes = projectId =>
  `${API_ROOT}/schedule/luminaireTypes/${projectId}`;
export const excelExport = projectId =>
  `${API_ROOT}/schedule/export/${projectId}`;

//issue draft
export const ISSUE_DRAFT = `${API_ROOT}/schedule/issueDraft`;

//all active companies
export const ALL_ACTIVE_COMPANIES = `${API_ROOT}/company/active`;
